<template>
	<ContractListOnline :stallionId="horse.horse_id" />
</template>

<script type="text/javascript">
	export default {
		name: "ContractStallionListOnline",
		props: ['horse'],
		components: {
			ContractListOnline: () => import('@/components/Contract/ContractListOnline')
		}
	}
</script>
